import { render, staticRenderFns } from "./ReplacementList.vue?vue&type=template&id=1fb704b6&scoped=true"
import script from "./ReplacementList.vue?vue&type=script&lang=js"
export * from "./ReplacementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb704b6",
  null
  
)

export default component.exports